import { SFHeaderMenuViewModel } from '@api/index';
import {
  BankCard,
  Bill,
  UserHeader,
  UserStar,
  UserSuitCase,
} from '@assets/icons/topHeader';
import STATIC_ROUTES from '@data/staticRoutes.json';

export const HEADER_MENU_ITEMS: Array<SFHeaderMenuViewModel> = [
  {
    name: 'Uçak',
    href: STATIC_ROUTES.flightPathPrefix,
    children: [],
  },
  {
    name: 'Otel',
    href: STATIC_ROUTES.hotelPathPrefix,
    children: [],
  },
  {
    name: 'Tur',
    href: STATIC_ROUTES.tourPathPrefix,
    children: [],
  },
  {
    name: 'Araç',
    href: STATIC_ROUTES.carRentalLandingPathPrefix,
    children: [],
  },
];

export const USER_MENU_ITEMS = [
  {
    id: 1,
    name: 'Kullanıcı Bilgilerim',
    href: STATIC_ROUTES.userInformation,
    icon: UserHeader,
    children: [],
  },
  {
    id: 2,
    name: 'Kayıtlı Yolcularım',
    href: STATIC_ROUTES.registeredPassengers,
    icon: UserStar,
    children: [],
  },
  {
    id: 3,
    name: 'Fatura Bilgilerim',
    href: STATIC_ROUTES.billingInformation,
    icon: Bill,
    children: [],
  },
  {
    id: 4,
    name: 'Kart Bilgilerim',
    href: STATIC_ROUTES.cardInformation,
    icon: BankCard,
    children: [],
  },
  {
    id: 5,
    name: 'Seyahatlerim',
    href: STATIC_ROUTES.travels,
    icon: UserSuitCase,
    children: [],
  },
];
